import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { CustomEase } from 'gsap/dist/CustomEase'
import { measureScrollBarWidth } from '@/helpers/dom'
import { registerMaterial3 } from '@/assets/scripts/motion/eases'
import { debounce } from '@/helpers/async'

gsap.registerPlugin(CustomEase)

function setupDebugHelpers() {
	window.debug = false
	window.logs = []
	window.log = function (context, message) {
		const log = `[${[context].flat().join('] [')}] ${message}`
		window.logs.push(log)

		if (window.debug) {
			console.log(log)
		}
	}
	document.addEventListener('keydown', function (event) {
		if (event.ctrlKey && event.shiftKey && event.key === 'D') {
			window.debug = !window.debug
			console.log('debug:', window.debug)
		}
	})
}

function setupScrollTrigger() {
	gsap.registerPlugin(ScrollTrigger)

	window.refreshScrollTrigger = debounce(function (deferToNextTick) {
		if (deferToNextTick) {
			window.$nuxt.$nextTick(() => ScrollTrigger.refresh())
		} else {
			ScrollTrigger.refresh()
		}
	}, 512)

	ScrollTrigger.addEventListener('refresh', () => window.log('ScrollTrigger', 'Refresh'))
}

function setupGlobalCssVariables() {
	const scrollBarWidth = measureScrollBarWidth()
	if (scrollBarWidth > 0) {
		document.documentElement.style.setProperty('--sbw', `${scrollBarWidth}px`)
	}
}

function setupCustomEase() {
	gsap.registerPlugin(CustomEase)

	registerMaterial3(CustomEase)
}

export function setupClientSideEnvironment(ctx) {
	setupDebugHelpers()
	setupScrollTrigger()
	setupCustomEase()
	setupGlobalCssVariables()
}
